import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { channelsHandler, handleChannelRemove, handleGroupDevicesFilter, handleReallocateChannels } from './helpers';
import { LoadWidgetHelper } from './loadWidgetHelper';

const loadGroupsInitialState: any = {
    filters: {},
    selectedNodes: [],
    secondary: [],
    viewAllButton: false,
    maxCount: 6,
    isAutomated: true,
    isTotalCountVisible: false,
    countMode: 'custom',
};

const loadGroupsWidgetSlice = createSlice({
    name: 'load_groups',
    initialState: loadGroupsInitialState,
    reducers: {
        resetLoadGroupsConfiguration: () => {
            return loadGroupsInitialState;
        },
        setPredefinedLoadGroups: (state: RootState, action: PayloadAction<any>) => {
            Object.keys(action.payload)?.forEach((key: string) => {
                if (key === 'selectedNodes') {
                    state[key] = action.payload[key];
                } else if (key === 'secondary') {
                    if (typeof action.payload[key][0] === 'string') {
                        state[key] = action.payload[key]?.map((item: any) => ({ id: item }));
                    } else {
                        state[key] = action.payload[key];
                    }
                } else state[key] = action.payload[key];
            });
        },
        setLoadGroups: (state: RootState, action: PayloadAction<any>) => {
            channelsHandler(state, action, 'id');
        },
        setLoadGroupsData: (state: RootState, action: PayloadAction<any>) => {
            state['secondary'] = action.payload;
        },
        setLoadGroupsFilters: (state: RootState, action: PayloadAction<any>) => {
            state['filters'] = action.payload;
        },
        reAllocateLoadGroups: (state: RootState, action: PayloadAction<any>) => {
            handleReallocateChannels(state, action);
        },
        removeLoadGroups: (state: RootState, action: PayloadAction<any>) => {
            handleChannelRemove(state, action, 'id');
        },
        setLoadGroupsNodes: (state: RootState, action: PayloadAction<any>) => {
            handleGroupDevicesFilter(state, action);
        },
        setLoadGroupsPreferences: (state: RootState, action: PayloadAction<any>) => {
            LoadWidgetHelper.setPreferences(state, action);
        },
    },
    extraReducers: (builder) => {
        LoadWidgetHelper.addExtraReducers(builder);
    },
});

export const {
    resetLoadGroupsConfiguration,
    setLoadGroupsFilters,
    setLoadGroupsNodes,
    reAllocateLoadGroups,
    setPredefinedLoadGroups,
    removeLoadGroups,
    setLoadGroups,
    setLoadGroupsData,
    setLoadGroupsPreferences,
} = loadGroupsWidgetSlice.actions;
export default loadGroupsWidgetSlice;
